import classNames from 'classnames';
import BasicPicker, {
  type IBasicPickerProps,
} from 'components/foundation/pickers/basic-picker/BasicPicker/BasicPicker';
import useEquipmentChecklists from 'containers/equipment-inspections/hooks/useEquipmentChecklists';
import useOnMount from 'hooks/utils/useOnMount/useOnMount';
import { t } from 'i18next';
import { useState } from 'react';
import { ClassName } from 'types/ClassName';

export interface IEquipmentInspectionChecklistPickerProps extends Omit<IBasicPickerProps, 'data'> {
  className?: ClassName;
  value: string | null;
  placeholder?: string;
  onSelect: (value: string | null) => void;
}

const EquipmentInspectionChecklistPicker = (props: IEquipmentInspectionChecklistPickerProps) => {
  const { className, placeholder, ...passthrough } = props;

  const { getEquipmentChecklists } = useEquipmentChecklists();

  const [data, setData] = useState<{ id: string; name: string }[]>([]);

  useOnMount(() => {
    getData();
  });

  const getData = async () => {
    const checklists = await getEquipmentChecklists();

    const pickerData = checklists.map((item) => ({
      id: item.id,
      name: item.checklistTitle,
    }));

    setData(pickerData);
  };

  const classes = classNames('equipment-inspection-checklist-picker', className);

  return <BasicPicker placeholder={placeholder ?? t('Checklist')} data={data} className={classes} {...passthrough} />;
};

export default EquipmentInspectionChecklistPicker;
